import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './Main_Layout';
import Home from './pages/home';
import AboutUs from './pages/about_us';
import ServicesSection from './pages/services';
import PromotionsSection from './pages/promotions';
import RealisationsSection from './pages/realisations';
import AdminLogin from './pages/admin_login';
import AdminDashboard from './pages/admin';
import ActivitiesSection from './pages/activities';
import JobsSection from './pages/jobs';
import TestimonialsSection from './pages/testimonials';
import FAQSection from './pages/faq';
import TeamSection from './pages/teams';
import ContactSection from './pages/contact_us';
import SubServicesSection from './pages/epargne';
import CreditSection from './pages/credit';
import ApplicationForm from './pages/application';
import './i18n';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<MainLayout><Home /></MainLayout>} />
        <Route path="/about_us" element={<MainLayout><AboutUs /></MainLayout>} />
        <Route path="/services" element={<MainLayout><ServicesSection /></MainLayout>} />
        <Route path="/promotions" element={<MainLayout><PromotionsSection /></MainLayout>} />
        <Route path="/realisations" element={<MainLayout><RealisationsSection /></MainLayout>} />
        <Route path="/activities" element={<MainLayout><ActivitiesSection /></MainLayout>} />
        <Route path="/jobs" element={<MainLayout><JobsSection /></MainLayout>} />
        <Route path="/faq" element={<MainLayout><FAQSection /></MainLayout>} />
        <Route path="/contact_us" element={<MainLayout><ContactSection /></MainLayout>} />
        <Route path="/teams" element={<MainLayout><TeamSection /></MainLayout>} />
        <Route path="/application" element={<MainLayout><ApplicationForm /></MainLayout>} />
        <Route path="/application/:jobId" element={<MainLayout><ApplicationForm /></MainLayout>} />
        <Route path="/credit" element={<MainLayout><CreditSection /></MainLayout>} />
        <Route path="/epargne" element={<MainLayout><SubServicesSection /></MainLayout>} />
        <Route path="/testimonials" element={<MainLayout><TestimonialsSection /></MainLayout>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;